<template>
  <div>
    <InputRadioGroup
      :legend="`Färg: ${store.productState.selectedColor}`"
      type-class="color"
    >
      <InputRadioColorPicker
        v-for="color in store.colorOptions"
        :key="color.ColorName"
        v-model="store.productState.selectedColor"
        :html-id="color.ColorName"
        :label="color.ColorName"
        :value="color.ColorName"
        :group-name="`colors-${groupNameId}`"
        :color="color.Color"
        @update:model-value="store.changeOption('colors')"
      />
    </InputRadioGroup>
  </div>
</template>

<script lang="ts" setup>
const store = useMyProductPageStore();
const groupNameId = useId();
</script>

<style></style>
